// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-table-columns-fixed-controller .d2-button[data-v-1aac2991] {\n  padding: 2px;\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
